import React from 'react';
import { Formik, Field } from 'formik';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TextField from '../InputFields/TextField';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';
import SelectField from '../InputFields/SelectField';

const SupportSearchContainerStyles = styled.div`
  width: 100%;
  line-height: 1;
`;

const SearchFieldWrapper = styled.div`
  margin-bottom: ${pxToRem(24)};

  ${mediaBelow(variables.breakpoints.bpMd)} {
    input {
      height: ${pxToRemMd(40)};
    }
  }
`;

const SupportSearchContainer = styled.div``;

const SupportSearchText = styled.div`
  margin-bottom: ${pxToRem(10)};
`;

const SelectFieldWrapper = styled.div`
  margin-bottom: ${pxToRem(16)};
`;

const LegacyOrderHistorySearch = ({
  setSearchValue,
  orderTypesList,
  orderStatusTypes,
  productList,
  setSelectedOrderType,
  setSelectedOrderStateType,
  setSelectedProductCode,
}) => {
  const { t } = useTranslation();

  const initialValues = {
    searchTerm: '',
    orderType: '',
    orderStatus: '',
    productCode: '',
  };

  return (
    <SupportSearchContainer>
      <SupportSearchText>
        {t('account.legacyOrderHistory.searchLabel')}
      </SupportSearchText>
      <SupportSearchContainerStyles>
        <Formik initialValues={initialValues}>
          {({ setFieldValue }) => (
            <>
              <SearchFieldWrapper>
                <Field
                  name="searchTerm"
                  placeholder="Search..."
                  component={TextField}
                  isSearch
                  onChange={(e) => {
                    setFieldValue('searchTerm', e.target.value);
                    setSearchValue(e.target.value);
                  }}
                />
              </SearchFieldWrapper>
              <SelectFieldWrapper>
                <SelectField
                  name="orderType"
                  label={t(
                    'account.legacyOrderHistory.filters.selectOrderType',
                  )}
                  options={orderTypesList}
                  selectOption={({ value }) => setSelectedOrderType(value)}
                />
              </SelectFieldWrapper>
              <SelectFieldWrapper>
                <SelectField
                  name="orderStatus"
                  label={t(
                    'account.legacyOrderHistory.filters.selectOrderStatus',
                  )}
                  options={orderStatusTypes}
                  selectOption={({ value }) => setSelectedOrderStateType(value)}
                />
              </SelectFieldWrapper>
              <SelectField
                name="productCode"
                label={t('account.legacyOrderHistory.filters.selectProduct')}
                options={productList}
                selectOption={({ value }) => setSelectedProductCode(value)}
              />
            </>
          )}
        </Formik>
      </SupportSearchContainerStyles>
    </SupportSearchContainer>
  );
};
LegacyOrderHistorySearch.propTypes = {
  setSearchValue: PropTypes.func,
  orderTypesList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  orderStatusTypes: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  productList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  setSelectedOrderType: PropTypes.func,
  setSelectedOrderStateType: PropTypes.func,
  setSelectedProductCode: PropTypes.func,
};
export default LegacyOrderHistorySearch;
